import axios from 'axios';
import store from '../../store/index';

export default {
	loadPlanningLogs(limit) {
		return axios.get(`/api/planningLogs/last?limit=${limit}`);
	},
	getStatus() {
		return axios.get(`/api/roster`);
	},
	setRunning(running) {
		return axios.post(running ? '/api/roster/start' : '/api/roster/stop');
	},
	resetRoster() {
		return axios.post('/api/roster/reset', {});
	},
	evaluate() {
		return axios.post('/api/roster/evaluate');
	},
	evaluatePlanning() {
		return axios.post('/api/roster/evaluatePlanning', {});
	},
	fullReload() {
		return axios.post('/api/roster/fullReload');
	},
	clearCache() {
		return axios.post('/api/roster/clearCache');
	},
};
